export default __webpack_public_path__ + "static/media/related1.9ed779c6.svg";